import { ParamasterUser } from './types';
import { Kode4GrowlMessage } from '@kode4/ui';

export const UI_RESET = "UI::RESET";
export const UI_BUSY = "UI::BUSY";
export const UI_TITLE = "UI::TITLE";
export const UI_SUBTITLE = "UI::SUBTITLE";
export const UI_HEADERCLASS = "UI::HEADERCLASS";
export const UI_FOOTERCLASS = "UI_FOOTERCLASS";
export const UI_BODYCLASS = "UI::BODYCLASS";
export const UI_SHOW_PAGE_HEADER = "UI::SHOW::PAGE::HEADER";
export const UI_SHOW_PAGE_FOOTER = "UI::SHOW::PAGE::FOOTER";
export const UI_INIT_I18N = "UI::INIT::I18N";
export const UI_I18N_LANG = "UI::I18N::LANG";
export const UI_I18N_LANGS = "UI::I18N::LANGS";
export const UI_LOGO_LANG = "UI::LOGO::LANG";
export const UI_I18N_COUNTRIES = "UI::I18N::COUNTRIES";
export const UI_I18N_CURRENCIES = "UI::I18N::CURRENCIES";
export const UI_I18N_EINHEITENSYSTEME = "UI::I18N::EINHEITENSYSTEME";
export const UI_USER = "UI::USER";
export const UI_MESSAGE = "UI::MESSAGE";
export const UI_MESSAGES = "UI::MESSAGES";
export const UI_USERLIST_MODE = "UI_USERLIST_MODE";
export const UI_USERLIST_FILTER = "UI_USERLIST_FILTER";

interface UiReset {
    type: typeof UI_RESET;
}

interface UiBusy {
    type: typeof UI_BUSY;
    busy: boolean;
}

interface UiTitle {
    type: typeof UI_TITLE;
    title: string;
}

interface UiSubTitle {
    type: typeof UI_SUBTITLE;
    subTitle: string;
}

interface UiHeaderClass {
    type: typeof UI_HEADERCLASS;
    cssClass: string;
}

interface UiFooterClass {
    type: typeof UI_FOOTERCLASS;
    cssClass: string;
}

interface UiBodyClass {
    type: typeof UI_BODYCLASS;
    cssClass: string;
}

interface UiShowPageHeader {
    type: typeof UI_SHOW_PAGE_HEADER;
    show: boolean;
}

interface UiShowPageFooter {
    type: typeof UI_SHOW_PAGE_FOOTER;
    show: boolean;
}

interface UiInitI18n {
    type: typeof UI_INIT_I18N;
    initialized: boolean;
}

interface UiI18nLang {
    type: typeof UI_I18N_LANG;
    lang: string;
}

interface UiI18nLangs {
    type: typeof UI_I18N_LANGS;
    langs: Array<string>;
}

interface UiLogoLang {
    type: typeof UI_LOGO_LANG;
    logoLang: string;
}

interface UiI18nCountries {
    type: typeof UI_I18N_COUNTRIES;
    countries: Array<string>;
}
interface UiI18nCurrencies {
    type: typeof UI_I18N_CURRENCIES;
    currencies: Array<string>;
}

interface UiI18nEinheitensysteme {
    type: typeof UI_I18N_EINHEITENSYSTEME;
    einheitensysteme: Map<number, string>;
}

interface UiUser {
    type: typeof UI_USER;
    user?: ParamasterUser;
}

interface UiMessage {
    type: typeof UI_MESSAGE;
    message: Kode4GrowlMessage;
}

interface UiMessages {
    type: typeof UI_MESSAGES;
    messages: Array<Kode4GrowlMessage>;
}

interface UiUserlistNode {
    type: typeof UI_USERLIST_MODE;
    mode: string;
}

interface UiUserlistFilter {
    type: typeof UI_USERLIST_FILTER;
    filter: string;
}

export type UiActionTypes =
    UiReset
    | UiBusy
    | UiTitle
    | UiSubTitle
    | UiHeaderClass
    | UiFooterClass
    | UiBodyClass
    | UiShowPageHeader
    | UiShowPageFooter
    | UiInitI18n
    | UiI18nLang
    | UiI18nLangs
    | UiLogoLang
    | UiI18nCountries
    | UiI18nCurrencies
    | UiI18nEinheitensysteme
    | UiUser
    | UiMessage
    | UiMessages
    | UiUserlistNode
    | UiUserlistFilter;
